export default __webpack_public_path__ + "static/web-transforming-analytics-2d65923372c5b4ad9b6d9529e406b0df.png";